import { IPartGroup } from "@drone-parts.garphild.pro/interfaces";
import { makeAutoObservable } from "mobx";
import RestApiQuery, { ApiEndpoints } from "../helpers/rest-api-query";
import { notification } from "antd";

class DictionaryStorage {
  productGroups: IPartGroup[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  loadDictionary = async () => {
    try {
    const response = await RestApiQuery.get<{ productGroups: IPartGroup[]}>(ApiEndpoints.Dictionary)
      if (!response) {
        throw new Error("Failed to load dictionary");
      }

      this.productGroups = response.productGroups
    } catch (error: any) {
      notification.error({ message: error.message });
    }
  }
}

const dictionaryStorage = new DictionaryStorage();

export default dictionaryStorage;
